export default "__VITE_ASSET__BIjPt9IE__"